import { render, staticRenderFns } from "./ISPDetailView.vue?vue&type=template&id=e48223dc&"
import script from "./ISPDetailView.vue?vue&type=script&lang=js&"
export * from "./ISPDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports